/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const checkTokenType =
  (context: any, event: any) => (callback: any, _onEvent: any) => {
    const data = event?.data?.value;

    if (data?.signInToken) {
      context.signInRes = data;
      console.log(`method=checkTokenType sign-in`);
      callback('SIGN_IN_TOKEN');
    } else if (data?.accessToken) {
      context.signInRes = data;
      console.log(`method=checkTokenType access`);
      callback('ACCESS_TOKEN');
    } else {
      console.log(`method=checkTokenType: unknown token type`, data);
      callback('ERROR');
    }
  };
